import React, { useEffect, useRef, useState } from "react";

import { useVideoSurveyInventory } from "../../../../hooks/useVideoSurveyInventory";
import { Destination } from "../../../../models/destination";
import { DifferentLocation as LocationAddress } from "../../../../models/location";
import { RoomJob } from "../../../../models/sales";
import getAllMaterialsFromRoom from "../../../../util/getAllMaterialsFromRoom";
import PicturesComponent from "../../../Generic/PicturesComponent";
import { HeaderInventoryList } from "./HeaderInventory";
import { InventoryListValues } from "./InventoryListValues";
import useStyles from "./styles";

type InventoryListProps = {
  room: RoomJob;
  indexRoom: number;
  destinations: Destination[];
  locations: LocationAddress[];
  isAllExpanded?: boolean;
  selectRoom?: (isExpanded: boolean) => void;
};

export const InventoryList = ({
  room,
  locations,
  destinations,
  selectRoom,
  indexRoom,
}: InventoryListProps) => {
  const {
    handleAddPicturesToRoom,
    handleDeletePicturesFromRoom,
    isInventoryCollapsed,
    setSelectedRoomName,
  } = useVideoSurveyInventory();
  const classes = useStyles();

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const inputfile = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setIsExpanded(isInventoryCollapsed);
  }, [isInventoryCollapsed]);

  return (
    <div className={classes.roomContentItemWrapper}>
      <div>
        <HeaderInventoryList
          room={room}
          indexRoom={indexRoom}
          selectRoom={selectRoom}
          handleChangeExpand={(expandedValue) => {
            setSelectedRoomName(expandedValue ? room?.name : "");
            setIsExpanded(expandedValue);
          }}
          isExpanded={isExpanded}
          handleClickPhoto={() => {
            inputfile?.current?.click();
          }}
        />
      </div>

      {isExpanded && (
        <InventoryListValues
          room={room}
          items={room.itemsJob}
          locations={locations}
          destinations={destinations}
          materials={getAllMaterialsFromRoom(room)}
        />
      )}
      <PicturesComponent
        ref={inputfile}
        classes={`${room.pictures && room.pictures.length > 0 ? "mt-3 pl-2" : "pl-2"}`}
        pictures={room.pictures || []}
        roomPictures={room.roomPictures}
        description={room.name}
        isExpanded={isExpanded}
        page="roomList"
        addPhoto={(photos: string[]) => handleAddPicturesToRoom(room.name, photos)}
        deletePhoto={(pictureIndex, uri) => handleDeletePicturesFromRoom(room.name, uri)}
      />
    </div>
  );
};
